export const hexToRgb = (hex) => {
  let h = hex.replace("#", "");
  if (h.length === 3)
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  const n = parseInt(h, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
};

export const toRgba = (hex, a = 1) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

// Apply alpha to a color string.
// Supports: #RGB, #RRGGBB, #RRGGBBAA, rgb(...), rgba(...)
export const withAlpha = (color, alpha = 1) => {
  if (!color) return color;

  if (typeof color !== "string") return color;
  const a = Math.max(0, Math.min(1, alpha));

  if (color.startsWith("rgba(")) {
    const m = color.match(
      /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([0-9.]+)\s*\)/i
    );
    if (!m) return color;
    const r = Number(m[1]);
    const g = Number(m[2]);
    const b = Number(m[3]);
    const baseA = Number(m[4]);
    return `rgba(${r}, ${g}, ${b}, ${Math.max(0, Math.min(1, baseA * a))})`;
  }

  if (color.startsWith("rgb(")) {
    const m = color.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i);
    if (!m) return color;
    const r = Number(m[1]);
    const g = Number(m[2]);
    const b = Number(m[3]);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    const isShort = hex.length === 3;
    const isLong = hex.length === 6;
    const isLongWithAlpha = hex.length === 8;
    if (!isShort && !isLong && !isLongWithAlpha) return color;

    const r = parseInt(isShort ? hex[0] + hex[0] : hex.slice(0, 2), 16);
    const g = parseInt(isShort ? hex[1] + hex[1] : hex.slice(2, 4), 16);
    const b = parseInt(isShort ? hex[2] + hex[2] : hex.slice(4, 6), 16);
    const baseA = isLongWithAlpha ? parseInt(hex.slice(6, 8), 16) / 255 : 1;
    return `rgba(${r}, ${g}, ${b}, ${Math.max(0, Math.min(1, baseA * a))})`;
  }

  return color;
};

export function getSlotColorWithOpacity(protocolSlot) {
  // 1. Strip the "-string" suffix
  const raw = protocolSlot.replace(/-string$/, "");
  // 2. Find the first uppercase letter to split priority vs. type
  const idx = raw.search(/[A-Z]/);
  const priority = raw.substring(0, idx).toLowerCase();

  // 3. Return the color based on priority
  switch (priority) {
    case "primary":
      return "rgba(255, 0, 0, 0.40)"; // Red
    case "secondary":
      return "rgba(63, 123, 141, 0.7)"; // Blue‐gray
    case "tertiary":
      return "rgba(34, 139, 34, 0.6)"; // Green
    case "quaternary":
      return "rgba(221, 145, 2, 0.6)"; // Orange
    case "quinary":
      return "rgba(216, 165, 173, 0.7)"; // Pink
    default:
      return "rgba(0, 0, 0, 0.5)"; // Fallback light gray
  }
}

//Function in case we change the color of execise.protocolSlot in chat
// export function getSlotColorWithOpacity(protocolSlot, darkBackground = false) {
//   // 1. Strip the "-string" suffix
//   const raw = protocolSlot.replace(/-string$/, "");
//   // 2. Find the first uppercase letter to split priority vs. type
//   const idx = raw.search(/[A-Z]/);
//   const priority = raw.substring(0, idx).toLowerCase();

//   // 3. Return the color based on priority
//   switch (priority) {
//     case "primary":
//       return darkBackground ? "rgba(255, 84, 58, 1)" : "rgba(212, 60, 0, 1)"; // Red
//     case "secondary":
//       return darkBackground ? "rgba(64, 163, 193, 1)" : "rgba(11, 109, 139, 1)"; // Blue‐gray
//     case "tertiary":
//       return darkBackground ? "rgba(63, 180, 63, 1)" : "rgba(34, 139, 34, 1)"; // Green
//     case "quaternary":
//       return darkBackground ? "rgba(236, 193, 64, 1)" : "rgba(175, 131, 0, 1)"; // Orange
//     case "quinary":
//       return darkBackground
//         ? "rgba(226, 140, 169, 1)"
//         : "rgba(219, 112, 147, 1)"; // Pink
//     default:
//       return darkBackground ? "rgba(255, 255, 255, 1)" : "rgba(0, 0, 0, 1)"; // Fallback light gray
//   }
// }
